export default __webpack_public_path__ + "static/media/kitchen3-before3.6c8e8e5d.jpg";